import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoadingService } from './services/loading.service';
import { LanguageService } from './services/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { AlertModalComponent } from "./components/alert-modal/alert-modal.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    TranslateModule,
    AlertModalComponent
],
  templateUrl: './app.component.html',
})

export class AppComponent implements OnInit {
  private readonly loadingService = inject(LoadingService);
  private readonly languageService = inject(LanguageService);

  loading$ = this.loadingService.loading$;

  ngOnInit(): void {
    this.languageService.setLanguage('pt-br');
  }
}
